{
	"type": "symbol",
	"minzoom": 11,
	"filter": ["!=", ["get", "advisory_plaque_value"], null],
	"layout": {
		"icon-image": [
			"coalesce",
			["image", ["concat", "safecurves:speed_plaque_", ["get", "advisory_plaque_value"]]]
		],
		"icon-size": 0.4,
		"icon-allow-overlap": true,
		"icon-offset": [0, 65]
	},
	"paint": {
		"icon-opacity": 1
	}
}
